export default "__VITE_ASSET__Pe3wSGyV__"